import i18n from "@/i18n";
import resources from "@/resources";
import router from "@/router";
import routes from "@/router/admin";
import store from "@/store";
import Vue from "vue";
import VuetifyAdmin from "@inulti/vuetify-admin";
import "@inulti/vuetify-admin/src/loader";
import { en } from "@inulti/vuetify-admin/src/locales";
import { dataProvider, authProvider, httpData } from "@/@core/http";
import { mdiCheckCircle, mdiAlertCircle, mdiInformation, mdiClose } from "@mdi/js";
import {
  PAGE_STATUSES,
  PAGE_TYPES,
  LIST_ITEMS_PER_PAGE,
  ADVANCED_CONTENT_SEARCH,
  GTM_FILTERS,
  JOURNAYA_FILTERS,
  LEADSPEDIA_FILTERS,
  FORM_TYPE_FILTERS,
  RINGBA_FILTERS,
  SUCCESS_FILTERS,
  AB_TEST_STATUSES,
  PHONE_NUMBER_STATUSES,
} from "@/constant";
/**
 * Load Admin UI components
 */
Vue.use(VuetifyAdmin);

/**
 * Init admin
 */
export default new VuetifyAdmin({
  router,
  store,
  i18n,
  title: "SiteRunner",
  routes,
  locales: {
    en,
  },
  translations: ["en"],
  dataProvider,
  authProvider,
  resources,
  httpData,
  options: {
    dateFormat: "long",
    list: {
      disableGlobalSearch: true,
      disableItemsPerPage: false,
      itemsPerPage: 20,
      itemsPerPageOptions: LIST_ITEMS_PER_PAGE,
    },
  },
  toastIcons: {
    info: mdiInformation,
    success: mdiCheckCircle,
    error: mdiAlertCircle,
    closeIcon: mdiClose,
  },
  constants: {
    PAGE_STATUSES,
    PAGE_TYPES,
    ADVANCED_CONTENT_SEARCH,
    GTM_FILTERS,
    JOURNAYA_FILTERS,
    LEADSPEDIA_FILTERS,
    FORM_TYPE_FILTERS,
    RINGBA_FILTERS,
    SUCCESS_FILTERS,
    AB_TEST_STATUSES,
    PHONE_NUMBER_STATUSES,
  },
});
